export const desimoneWatch = ['2038', '2130', '2131', '2205', '2010']; // 2089 제거
export const O2Watch = ['2086', '2847'];
export const isOneWatch = ['2761', '2834'];
export const O2ttobak = ['1994', '1995', '2005', '2006', '2022', '2086'];
export const O2single = ['1992', '1993'];
export const O2normal = ['1992', '2003', '2005', '2123'];
export const O2focus = ['1993', '2004', '2006', '2124', '2130', '2131'];
export const O2booster = ['1992', '1993', '2003', '2004', '2005', '2006', '2086', '2095', '2123', '2124', '2130', '2131', '2179', '2205', '2519', '2458', '2739', '2741', '2831', '2833', '2847', '2869'];
export const isFirstMonth40 = ['2239', '2240', '2241', '2242', '2243', '2244', '2245', '2246'];
export const maskGoodsOrMybiom = ['947', '1011', '979', '980', '984', '203', '256', '257'];
export const specialSet = ['00340001', '00340002'];
export const KidsStep2 = ['2412', '2413', '2581'];
export const halfPrice = ['2379', '2380', '2381', '2382', '2383', '2434', '2435', '2436', '2437'];

//goodsKind
export const kindCategories = {
    kindMyBiome: ['IntestBacteria', 'BabyPoopAnalysis', 'HarmfulBacteriaC', 'HarmfulBacteriaSet', 'IntestBacteriaSetGS'], // 장내세균분석
    kindDesimone: ['Desimone'], // 프로바이오틱스 유산균
    kindSubscription: ['Subscription' ], // 정기구독
    kindSubscriptionStipulateMultiOpt : ['StipulateMultiOpt'],
    kindSubscriptionTtobakcareCombi : ['TtobakcareCombi'],
    kindTtobakcareLAB: ['Ttobakcare'], // 또박케어LAB
    kindGeneAnalysis: ['GeneAnalysis'], // 분석서비스
    kindO2Booster: ['O2Booster'], // O2 booster
    kindCosmeticBau: ['CosmeticBau', 'CosmeticBauSet'], // 코스메틱바유,
    kindPreorder : ['Preorder'] //사전판매
  };

  export const goodsType = {
    subscription : 'SUBSCRIPTION',
    normal : 'NORMAL'
}

export const saleType = {
  normalSale : 'BASIC_SALE',
  subsbcriptionSale : 'SUBSCRIPTION_SALE',
  groupSale:'GROUP_SALE'
}

//반값또박 정책번호
export const halfPricePolicy = [45 , 48]